import React from 'react';
import { stageMeta } from '../lib/status';

export default function StatusPill({ stage }) {
  const meta = stageMeta[stage] || stageMeta.new;
  return (
    <span className={`inline-flex rounded-full border px-2.5 py-1 text-xs font-medium ${meta.tone}`}>
      {meta.label}
    </span>
  );
}
